module.exports = {"530602001":"凤凰街道","530602002":"龙泉街道","530602003":"太平街道","530602101":"旧圃镇","530602102":"永丰镇","530602103":"北闸镇","530602104":"盘河镇","530602105":"靖安镇","530602106":"洒渔镇","530602107":"乐居镇","530602108":"苏家院镇","530602109":"大山包镇","530602110":"炎山镇","530602201":"布嘎回族乡","530602202":"守望回族乡","530602203":"小龙洞回族彝族乡","530602206":"青岗岭回族彝族乡","530602210":"苏甲乡","530602212":"大寨子乡","530602214":"田坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530602.json
// module id = 2389
// module chunks = 0